import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Shotversionslist from "../ShotVersionsList/Shotversionslist.component.jsx";
import useStyles from "./ShotVersionDefaultTable.styles.js";

const ShotVersionDefaultTable = ({
  shotVersionList,
  taskList,
  fetchTasks,
  updateRefreshCounter,
  dragScreen,
  handleDragScreen,
  setDragFileEnterModal,
  handleShotDetailModalState,
  shotVersionToggle,
  fetchShotVersion,
  statusList,
  sid,
  shotID,
  projectId,
  tableRef,
  handleTableScroll,
  scrollValue,
}) => {
  const classes = useStyles();

  return (
    <TableContainer
      sx={{
        marginTop: "5px",
        height: "calc(100% - 10px)",
        overflowX: "auto",
        overflowY: "auto",
        width: "100%",
      }}
    >
      <Table stickyHeader aria-label="simple table">
        <TableHead className={classes.tableHeader}>
          <TableRow className={classes.tableRow}>
            <TableCell align="left" className={classes.shotVersionTableCellTwo}>
              Shot Version
            </TableCell>
            <TableCell align="center" className={classes.shotVersionTableCell}>
              Added On
            </TableCell>
            <TableCell align="center" className={classes.shotVersionTableCell}>
              Status
            </TableCell>
            <TableCell align="center" className={classes.shotVersionTableCell}>
              Updated By
            </TableCell>
            <TableCell align="center" className={classes.shotVersionTableCell}>
              Relate Task
            </TableCell>
            <TableCell
              align="center"
              className={classes.shotVersionTableCellTwo}
            >
              Comments
            </TableCell>
            <TableCell
              align="right"
              className={classes.shotVersionTableCellTwo}
            >
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody
          onScroll={handleTableScroll}
          onLoad={() => {
            if (tableRef?.current && tableRef?.current?.scrollTop) {
              tableRef.current.scrollTop = scrollValue;
            }
          }}
        >
          {shotVersionList.results?.map((shotVer) => {
            return (
              <Shotversionslist
                data={shotVer}
                taskList={taskList}
                fetchTasks={fetchTasks}
                sequenceId={sid}
                shotID={shotID}
                status={statusList}
                projectId={projectId}
                openShotDetailModal={handleShotDetailModalState}
                shotVersionToggle={shotVersionToggle}
                updateRefreshCounter={updateRefreshCounter}
                dragScreen={dragScreen}
                handleDragScreen={handleDragScreen}
                setDragFileEnterModal={setDragFileEnterModal}
                refetchVersions={fetchShotVersion}
                customFields={shotVersionList?.custom_fields}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ShotVersionDefaultTable;
